<template>
    <div v-html="details" class="details-container">
    </div>
</template>

<script>
    export default {
        props : {
            details : String
        },
		name : 'mattress-details',
		components: {}
	}
</script>